const onNextHandler = (topControlRef, bottomControlRef) => {
  try {
    topControlRef['current']['scrollLeft'] = topControlRef['current']['scrollLeft'] + 80;
  } catch (error) {
    console.error('ScrollLeft ->');
  }
  try {
    bottomControlRef['current']['scrollLeft'] = topControlRef['current']['scrollLeft'] + 80;
  } catch (error) {
    console.error('ScrollRight ->');
  }
};

const onPreviousHandler = (topControlRef, bottomControlRef) => {
  try {
    topControlRef['current']['scrollLeft'] = topControlRef['current']['scrollLeft'] - 80;
  } catch (error) {
    console.error('ScrollLeft ->');
  }
  try {
    bottomControlRef['current']['scrollLeft'] = topControlRef['current']['scrollLeft'] - 80;
  } catch (error) {
    console.error('ScrollRight ->');
  }
};

export  {onNextHandler, onPreviousHandler}